interface FilterBarProps {
  timeValue: string;
  onTimeChange: (value: string) => void;
  sortValue: string;
  onSortChange: (value: string) => void;
  tags: string[];
  activeTag: string;
  onTagChange: (value: string) => void;
  onReset: () => void;
}

const timeOptions = [
  { value: 'all', label: '全部时间' },
  { value: 'today', label: '今日' },
  { value: '3days', label: '近三天' },
  { value: '7days', label: '近一周' },
];

const sortOptions = [
  { value: 'latest', label: '最新' },
  { value: 'hot', label: '最热' },
];

export default function FilterBar({
  timeValue,
  onTimeChange,
  sortValue,
  onSortChange,
  tags,
  activeTag,
  onTagChange,
  onReset,
}: FilterBarProps) {
  const groupClass = 'flex items-center gap-1 rounded-full bg-background-200 p-1';
  const itemClass = (active: boolean) =>
    `whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium transition-colors ${
      active
        ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
        : 'text-foreground-600 hover:text-primary-600'
    }`;

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4">
      <div className="flex flex-col gap-4">
        <div className="flex flex-wrap items-center gap-3">
          <span className="text-xs font-medium text-foreground-500">时间段</span>
          <div className={groupClass}>
            {timeOptions.map((opt) => (
              <button
                key={opt.value}
                type="button"
                onClick={() => onTimeChange(opt.value)}
                className={itemClass(timeValue === opt.value)}
              >
                {opt.label}
              </button>
            ))}
          </div>

          <span className="text-xs font-medium text-foreground-500">排序</span>
          <div className={groupClass}>
            {sortOptions.map((opt) => (
              <button
                key={opt.value}
                type="button"
                onClick={() => onSortChange(opt.value)}
                className={itemClass(sortValue === opt.value)}
              >
                <i className={`mr-1 ${opt.value === 'hot' ? 'ri-fire-line' : 'ri-time-line'}`}></i>
                {opt.label}
              </button>
            ))}
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-2 border-t border-background-200 pt-4">
          <span className="text-xs font-medium text-foreground-500">热点标签</span>
          <button type="button" onClick={() => onTagChange('')} className={itemClass(activeTag === '')}>
            全部
          </button>
          {tags.map((tag) => (
            <button
              key={tag}
              type="button"
              onClick={() => onTagChange(tag)}
              className={`rounded-full px-3 py-1 text-xs font-medium transition-colors ${
                activeTag === tag
                  ? 'bg-accent-500 text-background-50 dark:text-foreground-950'
                  : 'bg-secondary-100 text-secondary-900 hover:bg-secondary-200'
              }`}
            >
              #{tag}
            </button>
          ))}
          <button
            type="button"
            onClick={onReset}
            className="ml-auto flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 py-1 text-xs text-foreground-500 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            <i className="ri-refresh-line"></i>
            重置筛选
          </button>
        </div>
      </div>
    </div>
  );
}